module.exports = __webpack_public_path__ + "static/media/hero-bg-blur.935a3779.png";